import React from 'react'
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import { CardActions } from "@mui/material";
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

export default function CatererDriverSec() {
  let navigate = useNavigate();
  return (
    <>

      <Box component='container'
        sx={{
          margin: '10px',
          marginTop: "80px",
          display: 'flex',
          flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' },
          justifyContent: { xl: 'space-evenly', lg: 'space-between' },
          alignItems: 'center'
        }}
      >
        <Box>
          <Box>
            <Card
              sx={{
                width: { lg: '600px', md: '480px', sm: '100%', xs: '100%' },
                // width: "100%",
                height: "412px",
              }}
            >
              <CardActionArea onClick={() => navigate('/becomecaterer')}>
                <CardMedia
                  component="img"
                  height="140"
                  // width="636px"
                  width="100%"
                  image="./images/caterer.svg"
                  alt="green iguana"
                />
                <CardContent>
                  <Box>
                    <Typography
                      gutterBottom
                      sx={{
                        fontWeight: "600",
                        fontSize: { lg: "24px", md: "24px", sm: "20px", xs: "18px" },
                        lineHeight: "36px",
                      }}
                      component="div"
                    >
                      Become a Caterer
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: { lg: "18px", md: "18px", sm: "16px", xs: "14px" },
                        lineHeight: "26.1px",
                        color: "#545359",
                        // width: "510px",
                        marginTop: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the
                      industry's standard dummy text ever since the 1500s.
                    </Typography>
                  </Box>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Box>
                  <Link to="/becomecaterer">
                    <Button
                      size="small"
                      color="success"
                      sx={{ textDecoration: "underline", textTransform: "none" }}
                    >
                      Register your restaurant
                    </Button>
                  </Link>
                </Box>
              </CardActions>
            </Card>
          </Box>
        </Box>

        <Box >
          <Box>
            <Card
              sx={{
                // width: "666px",
                width: { lg: '600px', md: '480px', sm: '100%', xs: '100%' },
                height: "412px",
                marginTop: { lg: "0px", md: "0px", sm: "20px", xs: "20px" }
              }}
            >
              <CardActionArea onClick={() => navigate('/becomedriver')}>
                <CardMedia
                  component="img"
                  height="140"
                  // width="636px"
                  // width="636px"
                  image="./images/driver.svg"
                  alt="green iguana"
                />
                <CardContent>
                  <Box>
                    <Typography
                      gutterBottom
                      sx={{
                        fontWeight: "600",
                        fontSize: { lg: "24px", md: "24px", sm: "20px", xs: "18px" },
                        lineHeight: "36px",
                      }}
                      component="div"
                    >
                      Driver with Eatcoast
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: { lg: "18px", md: "18px", sm: "16px", xs: "14px" },
                        lineHeight: "26.1px",
                        color: "#545359",
                        // width: "510px",
                        marginTop: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the
                      industry's standard dummy text ever since the 1500s.
                    </Typography>
                  </Box>
                </CardContent>
              </CardActionArea>
              <CardActions>
                <Box>
                  <Link to="/becomedriver">
                    <Button
                      size="small"
                      color="success"
                      sx={{ textDecoration: "underline", textTransform: "none" }}
                    >
                      Register as driver
                    </Button>
                  </Link>
                </Box>
              </CardActions>
            </Card>
          </Box>
        </Box>
      </Box>

    </>
  )
}
